<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/ylts/home">医疗特色</router-link> >
      <router-link to="/ylts/mingyi">盛京名医</router-link> >
      {{ content.name }}
    </div>
    <!-- 科室导航 -->
    <div class="container-width mb50">
      <div class="doctor_box">
        <div class="">
          <img :src="content.url" class="doctor_img" />
          <img
            src="@/assets/image/doctor_clip.png"
            alt=""
            class="doctor_clip"
          />
        </div>
        <div class="doctor_msg" v-if="DWIDTH == true">
          <h5>{{ content.name }} {{ content.sex == 1 ? "男" : "女" }}</h5>
          <p>职称：{{ content.zhicheng }}</p>
          <p>科室： {{ content.bingfang }}</p>
          <p style="width: 500px">
            常规出诊时间及地点：{{ content.visitInfo }}
          </p>
          <div class="yuyue">
            <img src="../../assets/image/yuyue.gif" />
          </div>
        </div>
      </div>
      <div class="doctor_message" v-if="DWIDTH == false">
        <h5 style="font-size: 1.4rem">
          {{ content.name }} {{ content.sex == 1 ? "男" : "女" }}
        </h5>
        <p style="font-size: 1.2rem; line-height: 30px">
          职称：{{ content.zhicheng }}
        </p>
        <p style="font-size: 1.2rem; line-height: 30px">
          科室： {{ content.bingfang }}
        </p>
        <p style="font-size: 1.2rem; line-height: 30px">
          常规出诊时间及地点：{{ content.visitInfo }}
        </p>
      </div>
      <div class="list">
        <div class="j-item"><span>医生简介</span></div>
        <div v-html="content.introduce" class="j-description"></div>
      </div>
      <div class="list">
        <div class="j-item"><span>专业特长</span></div>
        <div v-html="content.description" class="j-description"></div>
      </div>
      <div class="list">
        <div class="j-item"><span>相关医生</span></div>

        <div class="d-list">
          <div
            class="d-item"
            v-for="(item, index) in doctorListData"
            :key="index"
            v-if="item.id != content.id"
          >
            <div class="d-avatar" @click="godoctor(item.id)">
              <img :src="item.url" />
              <div class="d-description">
                <p class="multi-ellipsis">{{ item.description }}</p>
              </div>
            </div>
            <div class="d-name" @click="godoctor(item.id)">
              <span class="doctor_zhicheng">「 {{ item.zhicheng }} 」</span
              ><br />
              <span class="doctor_name">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from "../../service/ylts";
import config from "../../config/dev";
import BANNER from "../../components/banner/ylts";
export default {
  name: "MINGYIARTICLE",
  props: {},
  data() {
    return {
      navigationData: [
      {
          name: "科室介绍",
          path: "/ylts/home",
          width: "31%",
        },
        {
          name: "盛京名医",
          path: "/ylts/mingyi",
          width: "31%",
        },
        {
          name: "国家临床重点专科",
          path: "/ylts/zhuanke",
          width: "38%",
        },
        {
          name: "特色医疗中心",
          path: "/ylts/tese",
        },
        {
          name: "护理专业发展",
          path: "/ylts/huli",
        },
      ],
      currentPath: "/ylts/mingyi",
      content: {},
      config: config,
      doctorListData: [],
      changeData: false,
      sjkdData: [],
      mtksjData: [],
      ylzhData: [],
      maleImg: require("../../assets/image/male.png"),
      DWIDTH: true,
    };
  },
  components: { BANNER },
  created() {
    this.id = this.$route.params.id;
    this.init();
  },
  methods: {
    init() {
      let parmes = {
        id: this.id,
      };
      service.getDoctorDetail(parmes, (res) => {
        if (res.url) {
          res.url = `${config.url}/file/downloadFile/${res.url}?isDownload=true`;
        } else {
          res.url = this.maleImg;
        }
        this.content = { ...res };
        this.getdoctorList(res.departId);
        this.getksName(res.departId);
      });

      //盛京看点
      let parmes2 = {
        pageIndex: 1,
        pageSize: 6,
        isshow: "1",
        issuggest: "1",
      };
      service.getWatchList(parmes2, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.title = item.title.substr(0, 16) + "...";
          });
        }
        this.sjkdData = res.content || [];
      });
      service.getwzMediaViewsjList(parmes2, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.title = item.title.substr(0, 16) + "...";
          });
        }
        this.mtksjData = res.content || [];
      });
      service.getwzMedicalAffairsList(parmes2, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.title = item.title.substr(0, 16) + "...";
          });
        }
        this.ylzhData = res.content || [];
      });
    },
    getksName(id) {
      let parmes = {
        id: id,
      };
      service.getDepartmentInfo(parmes, (res) => {
        this.content.bingfang = res.name || "";
      });
    },
    getdoctorList(id) {
      let parmes = {
        pageIndex: 1,
        pageSize: 200,
        departId: id,
      };
      service.getArcDocList(parmes, (res) => {
        if (res.length) {
          res.map((item) => {
            item.description = this.removeHTMLTag(item.description) || "";
            if (item.url) {
              item.url = `${config.url}/file/downloadFile/${item.url}?isDownload=true`;
            } else {
              item.url = this.maleImg;
            }
          });
        }
        this.doctorListData = res || [];
      });
    },
    godoctor(id) {
      this.changeData = !this.changeData;
      let articleId = id;
      const { href } = this.$router.resolve({
        path: `/ylts/mingyi/doctor/${articleId}`,
      });
      window.open(href, "_blank");
    },
    goylzhArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let articleId = e.id;
        const { href } = this.$router.resolve({
          path: `/sjkd/ylzh/article/${articleId}`,
        });
        window.open(href, "_blank");
      }
    },
    gomtksjArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let articleId = e.id;
        const { href } = this.$router.resolve({
          path: `/lxwm/mtksj/article/${articleId}`,
        });
        window.open(href, "_blank");
      }
    },
    gokdArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let articleId = e.id;
        const { href } = this.$router.resolve({
          path: `/sjkd/article/${articleId}`,
        });
        window.open(href, "_blank");
      }
    },
    goKs() {
      let articleId = this.content.departId;
      const { href } = this.$router.resolve({
        path: `/ylts/kslist/article/${articleId}`,
      });
      window.open(href, "_blank");
    },
    removeHTMLTag(str) {
      str = str
        ? str
            .replace(/<\/?.+?\/?>/g, "")
            .replace(/&nbsp;/g, "")
            .trim()
        : "";
      return str;
    },
  },
  mounted() {
    // 设备宽度小于720px 时
    if (window.screen.width < 720) {
      this.DWIDTH = false;
    } else {
      this.DWIDTH = true;
    }
  },
};
</script>

<style scoped lang="scss">
.container-width {
  overflow: hidden;
}
.doctor_box {
  width: 100%;
  position: relative;
  padding-left: 328px;
  padding-top: 1px;
  margin-top: 50px;
  margin-bottom: 50px;
  height: 430px;
}
.doctor_clip {
  position: absolute;
  left: 0;
  top: 0;
}
.doctor_img {
  /*width: 206px;*/
  /* height: 262px; */
  position: absolute;
  left: 55px;
  top: 71px;
  height: 80%;
  width: auto;
}

.doctor_msg {
  position: relative;
  z-index: 1;
  background-color: #fff;
  box-shadow: 5px 5px 24px -6px rgba(51, 51, 51, 0.1);
  margin-top: 33px;
  padding: 38px;
  min-height: 361px;
  box-sizing: border-box;

  .yuyue {
    position: absolute;
    right: 38px;
    bottom: 38px;
    width: 320px;
    img {
      width: 100%;
    }
  }
}
.doctor_msg h5 {
  font-size: 1.4rem;
  color: #333;
  line-height: 30px;
}
.doctor_msg h5 span {
  font-size: 16px;
  color: #333;
}
.doctor_msg img {
  margin-top: 26px;
  display: block;
}
.doctor_msg p {
  font-size: 14px;
  line-height: 28px;
  color: #333;
  margin-top: 15px;
}
.list {
  .j-item {
    border-bottom: 1px solid #00479d;
    span {
      display: inline-block;
      width: 180px;
      background: #00479d;
      color: #fff;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
  }
  .j-description {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 1.1rem;
    line-height: 40px;
    color: #333;
  }
}

.d-list {
  width: 100%;
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  row-gap: 30px;
  column-gap: 30px;
  margin-top: 50px;
  .d-item {
    width: 100%;
    margin-right: 15px;
    //height: 382px;/* 显示6个的时候 */

    overflow: hidden;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    cursor: pointer;
    .d-avatar {
      position: relative;
      // height: 342px; /* 显示6个的时候 */
      // width: 205px; /* 显示6个的时候 */
      text-align: center;
      img {
        -webkit-transform: scale(1);
        transform: scale(1);
        -webkit-transition: all 0.4s ease;
        transition: all 0.4s ease;
        max-width: 100%; /* 显示6个的时候 */
        height: 180px; /* 显示6个的时候 */
        overflow: hidden;
      }
      .d-description {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: url(../../assets/image/mask40.png);
        text-align: center;
        color: #fff;
        line-height: 24px;
        font-size: 14px;
        overflow: hidden;
        padding: 10px 20px;
        box-sizing: border-box;
        height: 70px;
      }
    }
    .d-name {
      height: 60px;
      flex: 1;
      text-align: center;

      .doctor_zhicheng {
        font-size: 12px;
        color: #333;
      }
      .doctor_name {
        font-size: 1.2rem;
        // color: #333;
        font-weight: 600;
      }
    }
  }
}
@media only screen and (max-width: 420px) {
  .d-list {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 15px;
    column-gap: 15px;
    margin-top: 15px;
  }
  .doctor_msg {
    padding: 15px;
    box-sizing: border-box;
    width: calc(100% - 360px);
  }
}
@media only screen and (min-width: 421px) and (max-width: 720px) {
  .d-list {
    grid-template-columns: repeat(4, 1fr);
    row-gap: 15px;
    column-gap: 15px;
    margin-top: 15px;
  }
}
@media only screen and (min-width: 721px) and (max-width: 1280px) {
  .d-list {
    grid-template-columns: repeat(6, 1fr);
    row-gap: 15px;
    column-gap: 15px;
    margin-top: 15px;
  }
}
@media only screen and (min-width: 1281px) {
  .d-list {
    grid-template-columns: repeat(8, 1fr);
    row-gap: 30px;
    column-gap: 30px;
    margin-top: 30px;
  }
}
</style>
